import { useTranslation } from "react-i18next";
import { Button, type ButtonProps } from "~/common/mui";
import DescriptionIcon from "@mui/icons-material/Description";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

type AddToCartButtonProps = {
  actionVariant?: "cart" | "quote" | "salesman";
} & Omit<ButtonProps, "children">;
export const AddToCartButtonBase = (props: AddToCartButtonProps) => {
  const { t } = useTranslation();
  const { actionVariant = "cart", ...rest } = props;

  let icon;
  let label;
  if (actionVariant === "cart") {
    icon = <ShoppingCartIcon sx={{ fontSize: { phone: 16, tablet: 20 } }} />;
    label = t("addToCartPopup.add.submitBtn");
  } else if (actionVariant === "quote") {
    icon = <DescriptionIcon sx={{ fontSize: { phone: 16, tablet: 20 } }} />;
    label = t("cartPage.btn.quote");
  } else {
    icon = <ShoppingCartIcon sx={{ fontSize: { phone: 16, tablet: 20 } }} />;
    label = t("basket.addToQuote");
  }

  return (
    <Button fullWidth={true} startIcon={icon} data-test-id={"btn-add-to-cart"} {...rest}>
      {label}
    </Button>
  );
};
